"use strict";
import {templates} from "Subschema";
import {wideContainer, splitContainer} from "./CreditContainerBase.less";
import {promoContainer} from "./CreditPromoContainerBase.less";
import {container} from "./CreditContainer.less";

export const CreditContainer = {
    'template': "DotContainer",
    'containerClass': `${splitContainer} ${container}`,
    'position': 8,
    'count': 0,
    'style': 'CreditContainerBase'
};

export const CreditPromoContainer = {
	'template': "DotContainer",
	'containerClass': `${promoContainer}`,
	'style': 'CreditPromoContainerBase'
};

export const CreditWideContainer = {
    'template': "DotContainer",
    'containerClass': `${wideContainer} ${container}`,
    'position': 9,
    'count': 0

};

export default ({
    CreditContainer,
    CreditWideContainer,
	CreditPromoContainer
});


/** WEBPACK FOOTER **
 ** ./src/templates/CreditContainerBundle.js
 **/